import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    continue: 'Continue',
    inputs: {
      capital: {
        errors: {
          invalid: 'The company capital amount is invalid',
          minValue: 'The minimum company capital amount is {minimumAmount}',
          missing:
            'We need your company capital amount to comply with regulations',
        },
        label: 'Company capital amount (€)',
      },
      employees: {
        label: 'Number of employees',
      },
      turnover: {
        label: 'Annual turnover (€)',
      },
    },
    title: 'Complete your company’s financial information',
  },
  fr: {
    continue: 'Continuer',
    inputs: {
      capital: {
        errors: {
          invalid: 'Le montant du capital social est invalide',
          minValue:
            'Le montant minimum du capital social est de {minimumAmount}',
          missing:
            'La loi nous oblige à connaître le capital de votre entreprise',
        },
        label: 'Montant du capital social de la société (€)',
      },
      employees: {
        label: 'Nombre de salarié•e•s',
      },
      turnover: {
        label: 'Chiffre d’affaire annuel (€)',
      },
    },
    title: 'Compléter les données financières de votre entreprise',
  },
} as const);
